/* import __COLOCATED_TEMPLATE__ from './lsg-share-buttons.hbs'; */
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: [
    'LSG-c-share-buttons'
  ],

  /**
   * Register Services
   */
  socialCommandService : service('social/social-commands'),

  /***************************************
   *          REQUIRED PARAMS
   ***************************************/

  /**
   * @param {String}      Main title for all sharing.
   */
  title: '',

  /**
   * @param {String}     Url for any of the widgets that require it.
   */
  url: '',

  /***************************************
   *          OPTIONAL PARAMS
   ***************************************/

  /**
   * @param {String}      Use this only if you want to override the description for the email in the email case.
   */
  emailDescription: '',

  /**
   * @param {String=}     Description of the content that will be shared.
   */
  description: '',

  /**
   * @param {Boolean=}    True if you want to see the 'Share' text
   */
  isShowShareText: true,

  /**
   * @param {Array<String>=}   Array of hashtags for twitter.
   */
  twitterHashTags: A(),

  actions: {
    /**
     * Twitter clicked on
     */
    onTwitterClicked: function() {
      this.get('socialCommandService').shareTweet(
        this.get('title'),
        this.get('twitterHashTags'),
        this.get('url'));
    },

    /**
     * LinkedIn clicked on
     */
    onLinkedInClicked: function() {
      this.get('socialCommandService').shareLinkedIn(
        this.get('title'),
        this.get('description'),
        this.get('url')
      );
    },

    /**
     * Facebook clicked on
     */
    onFacebookClicked: function() {
      this.get('socialCommandService').shareWithFacebook(
        this.get('url')
      );
    },

    /**
     * Email clicked on
     */
    onEmailClicked: function() {
      let description = this.get('emailDescription');
      if (!description) {
        description = this.get('description');
      }

      this.get('socialCommandService').shareEmail(this.get('title'), description);
    }
  }
});
